import { Component, Input } from '@angular/core';

@Component({
  selector: 'dg-fb-legend',
  templateUrl: './legend.component.html',
})
export class LegendComponent {
  @Input() classes = '';
}
